if (!customElements.get('collapsible-section')) {
    customElements.define(
      'collapsible-section',
      class CollapsibleSection extends HTMLElement {
        static get observedAttributes() {
          return ['open'];
        }
  
        defaultSettings = {
          mblimit: 100,
          dtlimit: 150,
          needFocus: true,
        };
  
        constructor() {
          super();
          this.showMore = this.querySelector('.js-show-more');
          this.showLess = this.querySelector('.js-show-less');
          this.content = this.querySelector('.js-content');
          this.settings = this.getAttribute('settings');
        }
  
        getSettings() {
          if (!this.settings) {
            this.settings = this.defaultSettings;
            return;
          }
  
          try {
            const parsed = JSON.parse(this.settings);
            this.settings = parsed;
          } catch (error) {
            console.error('Error during parsing');
            this.settings = this.defaultSettings;
          }
        }
  
        toggleOpen() {
          this.toggleAttribute('open');
        }
  
        updateView(toOpen) {
          this.showMore?.classList.toggle('hidden', toOpen);
          this.showLess?.classList.toggle('hidden', !toOpen);
  
          const maxHeight = toOpen ? `${this.content.scrollHeight}px` : null;
          this.content.style.setProperty(
            '--mb-max-height',
            maxHeight || `${this.settings.mblimit}px`
          );
          this.content.style.setProperty(
            '--dt-max-height',
            maxHeight || `${this.settings.dtlimit}px`
          );
  
          if (!toOpen && this.settings.needFocus) {
            this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
  
        attributeChangedCallback(name, oldValue, newValue) {
          if (name === 'open' && oldValue !== newValue) {
            this.updateView(newValue === '');
          }
        }
  
        connectedCallback() {
          this.showMore.addEventListener('click', () => this.toggleOpen());
          this.showLess.addEventListener('click', () => this.toggleOpen());
          this.getSettings();
        }
      }
    );
  }
  